import React, {useState, useEffect} from 'react'
import '../assets/style/contact.css'
import { BsFillTelephoneFill } from 'react-icons/bs'
import { MdEmail } from 'react-icons/md' 
import { AiFillGithub, AiFillLinkedin } from 'react-icons/ai'
import { useForm } from '@formspree/react';

const Contact = () => {
    const [state, handleSubmit] = useForm("mvojrano");
    const [formresponse, setFormresponse] = useState();

    useEffect(()=>{
        if (state.succeeded) {
            setFormresponse('form-submitted successfully');
        }
    },[state])
    return (
        <>
            <div className="contact">
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-md-4 ct-left p-0">
                            <h2>Get in touch</h2>
                            <h3>Let's talk about your project</h3>
                            <p>Thinking about a new project, a problem to solve, or just want to connect? Let's do it!</p>
                            <p>Use the form on this page or get in touch by other means.</p>
                            <div className="st-socials">
                                <div className="stlist d-flex gap-3">
                                    <BsFillTelephoneFill className='st-icon' /><h5>Phone: <a href="tel:9910611594">9910611594</a></h5>
                                </div>
                                <div className="stlist d-flex gap-3">
                                    <MdEmail className='st-icon' /><h5>Email: <a href="mailto:ajaykumar.builds@gmail.com">ajaykumar.builds@gmail.com</a></h5>
                                </div>
                                <div className="stlist d-flex gap-3">
                                    <AiFillLinkedin className='st-icon' /><h5>Linkedin: <a href="https://www.linkedin.com/in/ajaykumar2070">Ajay Kumar</a></h5>
                                </div>
                                <div className="stlist d-flex gap-3">
                                    <AiFillGithub className='st-icon' /><h5>Github: <a href="https://github.com/ajaykumar2070">Ajay Kumar</a></h5>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-8 ct-right p-0">
                            <form onSubmit={handleSubmit} className='contact-form'>
                                <div className="label">
                                    <h6>Your contact information</h6>
                                </div>
                                <div className="fields d-flex fs-text">
                                    <input type="text" name='f_name' placeholder='First Name'/>
                                    <input type="text" name='l_name' placeholder='Last Name'/>
                                    <input type="text" name='email' placeholder='Email Address'/>
                                    <input type="text" name='cp_name' placeholder='Company Name'/>
                                    <input type="text" name='phone' placeholder='Phone Number'/>
                                    <input type="text" name='location' placeholder='Location'/>
                                </div>
                                <div className="label">
                                    <h6>What services do you need for your project?</h6>
                                </div>
                                <div className="fields d-flex fs-check">
                                    <span><input type="checkbox" name='services' value='App Development'/>App Development</span>
                                    <span><input type="checkbox" name='services' value='Website Development'/>Website Development</span>
                                    <span><input type="checkbox" name='services' value='PSD To HTML'/>PSD To HTML</span>
                                    <span><input type="checkbox" name='services' value='Wordpress Website'/>Wordpress Website</span>
                                    <span><input type="checkbox" name='services' value='Website Design'/>Website Design</span>
                                    <span><input type="checkbox" name='services' value='E-commerce Website'/>E-commerce Site</span>
                                </div>
                                <div className="label">
                                    <h6>How much is the anticipated budget?</h6>
                                </div>
                                <div className="fields d-flex fs-radio">
                                <span><input type="radio" name='budget' value='$100-$500'/>$100-$500</span>
                                <span><input type="radio" name='budget' value='$500-$1500'/>$500-$1500</span>
                                <span><input type="radio" name='budget' value='$1500-$3000'/>$1500-$3000</span>
                                </div>
                                <div className="label">
                                    <h6>Tell me about your project</h6>
                                </div>
                                <div className="fields d-flex">
                                    <textarea name="message" rows='5' placeholder='Message'></textarea>
                                </div>

                                <div className="btn-bg mt-32">
                                    <button className='download-btn w-100'>Submit</button>
                                </div>
                                <span>{formresponse}</span>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}
export default Contact